import { render, staticRenderFns } from "./HrSalaryBonusTax.vue?vue&type=template&id=5d55f72d&scoped=true&"
import script from "./HrSalaryBonusTax.vue?vue&type=script&lang=js&"
export * from "./HrSalaryBonusTax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d55f72d",
  null
  
)

export default component.exports